function showContent(contentId) {
  const SpecContents = document.querySelectorAll(".spec-content");
  const buttons = document.querySelectorAll("#custom-navigation button");

  SpecContents.forEach((content) => {
    content.classList.remove("active");
  });

  buttons.forEach((button) => {
    button.classList.remove("active");
  });

  document.getElementById(contentId).classList.add("active");
  document
    .querySelector(`#custom-navigation button[onclick*="${contentId}"]`)
    .classList.add("active");
}
